import $ from 'jquery';

export function initInScope ($scope) {
    $scope.find('.js-file-input').on('change', function () {
        var $element = $(this),
            $input = $element.find(':file'),
            $label = $element.find('.js-file-input__text'),
            numFiles = $input.get(0).files ? $input.get(0).files.length : 1,
            label = $input.val().replace(/\\/g, '/').replace(/.*\//, '');

        if (numFiles === 0) {
            label = $element.data('file-input-default-text');
        } else if (numFiles > 1) {
            label = $element.data('file-input-multiple-text').replace('[count]', numFiles);
        }

        $label.text(label);
    });
}